import * as React from "react";
import styles from "./styles.scss";

type Props = {
  children: React.ReactNode;
};

export const TagFilterContainer = ({ children }: Props) => {
  return <div className={styles.root}>{children}</div>;
};
